import { createContext } from 'react'

/**
 * OrderMethodContext
 * Create OrderMethod context for custom hook
 */
const OrderMethodContext = createContext({
  OrderMethods: {},
})

export default OrderMethodContext
